import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const SearchResults = lazy(
  () =>
    import('./SearchResults.eager').then(mod => ({
      default: mod.SearchResults,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
